import { UpdateBankInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const UpdateBankInputSchema: z.ZodType<UpdateBankInput> = z.object({
  bank: z.string().optional(),
  bank_code: z.string(),
  agencia: z.string(),
  agencia_dv: z.string().nullable(),
  conta: z.string(),
  conta_dv: z.string().nullable(),
  document_number: z.string().optional(),
});
